// extracted by mini-css-extract-plugin
export var notificationHost = "_lm-0";